import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { cardClass, primaryButtonClass } from "../components/register/styles";

export function SuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[var(--color-grey)] via-[var(--color-white)] to-[var(--color-grey)] p-4 dark:from-[var(--color-darkmode)] dark:via-[var(--color-deepSlate)] dark:to-[var(--color-darkmode)]">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className={`max-w-md text-center ${cardClass}`}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.1 }}
          className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-[var(--color-success)]/15 dark:bg-[var(--color-success)]/20"
        >
          <CheckCircle2 size={32} className="text-[var(--color-success)]" strokeWidth={2.5} />
        </motion.div>
        <h1 className="text-2xl font-extrabold tracking-tight text-[var(--color-midnight_text)] dark:text-[var(--color-white)]">{t("successTitle")}</h1>
        <p className="mt-3 text-sm text-[var(--color-section)] dark:text-[var(--color-muted)]">{t("successDescription")}</p>
        <button onClick={() => navigate("/register")} className={`${primaryButtonClass} mt-7 w-full`}>{t("newRegistration")}</button>
      </motion.div>
    </div>
  );
}
